import { useTranslation } from 'react-i18next';

import Hr from '../../components/Style/hr';
import DescriptionSplit from '../../components/Description/description-split';
import Link from '../../components/Links/link';
import Button from '../../components/Buttons/button';
import TitlePaymentLink from '../../components/title-payment-link';

export default function PaidStepPaymentLink() {
    const { t } = useTranslation();

    return (
        <div className='px-4 md:px-0 mb-6'>
            <TitlePaymentLink title={t('pagePaymentLink.paid.welcomeMessage')} description={t('pagePaymentLink.paid.description')} step="3" />
            <Hr />
            <DescriptionSplit description={t('pagePaymentLink.paid.descriptionSplit')} opacity='100' className='text-secondary' />

            <div className='mt-12 text-center'>
                <Link link={"/"} disableHoverEffect={true}>
                    <Button text={t('pagePaymentLink.paid.button')} />
                </Link>
            </div>
        </div>
    );
}